<div class="table-responsive">
  <table *ngIf="discounts.length>0" class="table table-hover table-sm align-middle border border-secondary rounded-4 p-2">
    <thead class="table-primary text-center">
      <tr>
        <th>Anticipo</th>
        <th>Descripción</th>
      <th>Voto</th>
      <th>Valor</th>
      <th>Acciones</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let d of discounts" class="text-center">
      <td class="form-label-sm">{{ d.title }}</td>
      <td class="form-label-sm">{{ d.description }}</td>
      <td class="form-label-sm">{{ d.vote }}</td>
      <td class="form-label-sm">${{ d.value | number:'1.0-0':'es-ES' }}</td>
      <td>
        <button class="btn btn-warning btn-sm me-1" title="Editar" (click)="editDiscount(d)" [disabled]="userRole !== 'Administrador'">
          <i class="bi bi-pencil-square"></i>
        </button>
        <button class="btn btn-danger btn-sm" title="Eliminar" (click)="deleteDiscount(d)" [disabled]="userRole !== 'Administrador'">
          <i class="bi bi-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
</div>

<div *ngIf="discounts.length==0" class="p-2">
  <p>
    No hay descuentos para este usuario en este periodo
  </p>
</div>

<div #addUserConceptModal class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-add-edit-discounts></app-add-edit-discounts>
    </div>
  </div>

</div>